<template>
    <Field :name="name" v-slot="{ field, errors }" v-bind="fieldValidateOn">
        <Select
            v-model="field.value"
            @update:modelValue="field['onUpdate:modelValue']"
            @blur="field.onBlur"
            @change="field.onChange"
            :errorMessages="errors"
            :field-error="!isEmpty(errors)"
            v-bind="input" />
    </Field>
</template>

<script lang="ts">
    import { PropType, ExtractPropTypes, defineComponent, inject } from 'vue';
    import { FieldValidateOn } from '../../Validations/Validations.interfaces';
    import { Field } from 'vee-validate';
    import { isEmpty } from 'lodash';
    import Select from './Select.vue';

    type SelectProps = ExtractPropTypes<typeof Select.props>;

    export default defineComponent({
        name: 'SelectField',
        methods: { isEmpty },
        components: { Field, Select },
        props: {
            name: {
                type: String,
                required: true,
            },
            input: {
                type: Object as PropType<Partial<SelectProps>>,
                default: () => ({}),
            },
        },
        setup() {
            const fieldValidateOn = inject('fieldValidateOn') as FieldValidateOn;

            return { fieldValidateOn };
        },
    });
</script>
